import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import isBefore from 'date-fns/is_before';

import { getAuthInLocalStorage } from '../utils/localStorage';

function ProtectedRoute({ component: Component, ...rest }) {
  const auth = getAuthInLocalStorage();
  let isValid = false;

  if (auth) {
    isValid = !!auth.token && !isBefore(new Date(auth.expire), new Date());
  }

  return (
    <Route
      {...rest}
      render={props => (isValid ? <Component {...props} /> : <Redirect to="/login" />)
      }
    />
  );
}

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default ProtectedRoute;
